'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minutes;


// WEBPACK FOOTER //
// ./~/sugar-date/number/minutes.js